import script from "./FieldDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./FieldDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./FieldDrawer.vue?vue&type=style&index=0&id=63b84d52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63b84d52"]])

export default __exports__